export interface NavigationPermissionRule {
  permission?: string;
  permissionsAny?: string[];
  permissionSetsAny?: string[][];
}
export function navigationAllowed(
  rule: NavigationPermissionRule,
  permissions: ReadonlySet<string>,
) {
  return (
    (!rule.permission || permissions.has(rule.permission)) &&
    (!rule.permissionsAny ||
      rule.permissionsAny.some((x) => permissions.has(x))) &&
    (!rule.permissionSetsAny ||
      rule.permissionSetsAny.some(
        (set) => set.length > 0 && set.every((x) => permissions.has(x)),
      ))
  );
}
